import Page from '../../components/Page';
import React from 'react';
import {Card, CardBody, CardHeader, Col, Row, Button, Table} from 'reactstrap';
import {Link} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import API from "../../resources/index";

class CompanyDetailPage extends React.Component {
    companyResource = API.companyResource;

    constructor() {
        super();
        this.state = {
            company: {}
        }
    }

    componentDidMount() {
        if (this.props.match.params && this.props.match.params.company_id) {
            this.companyResource.fetch(this.props.match.params.company_id, {
                keys: {
                    expand: [
                        'manager',
                        'manager.auth',
                        'audits',
                        'audits.auditor'
                    ]
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        this.setState({company: response.data});
                    }
                })
        }
    }

    async deleteCompany(company) {
        if (window.confirm(`Atenção!!! Esta operação é irreversível.\nTem certeza que deseja excluir a empresa "${company.social_name}" ?`)) {
            this.companyResource.delete(company.id)
                .then(response => {
                    if (response.status === 204) {
                        this.props.history.push('/companies');
                    }

                })
        }
    }

    render() {
        const {company} = this.state;
        const {user} = this.props;

        return <Page
            title="Detalhe Empresa"
            breadcrumbs={[
                {name: 'Empresas', active: false},
                {name: 'Detalhe Empresa', active: true}
            ]}
            className="">

            <Row>
                <Col>
                    <Row>
                        <Col>
                            <Card className="mb-3">
                                <CardHeader>
                                    <Link className='btn btn-outline-secondary mr-2'
                                          to={`/companies`}>
                                        Empresas
                                    </Link>

                                    <Link className='btn btn-outline-secondary mr-2'
                                          to={`/companies/form/${company.id}`}>
                                        Editar
                                    </Link>

                                    {(company && user) && (company.auth_id !== user.id) &&
                                    <Button color="danger" onClick={() => this.deleteCompany(company)}>Apagar</Button>}
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <p>Razão Social / Nome Fantasia</p>
                                            <h4>{company.social_name}</h4>
                                        </Col>
                                        <Col>
                                            <p>CPF / CNPJ</p>
                                            <h4>{company.cpf_cnpj}</h4>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <p>Telefone</p>
                                            <h4>{company.phone}</h4>
                                        </Col>
                                        <Col>
                                            <p>Status</p>
                                            <h4>{company.is_activated ? 'Sim' : 'Não'}</h4>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <p>Status de Pagamento</p>
                                            <h4>{company.status_payment}</h4>
                                        </Col>
                                        {(user && user.level === 1) &&
                                        <Col>
                                            <p>Código de acesso</p>
                                            <h4>{company.token}</h4>
                                        </Col>
                                        }
                                    </Row>
                                    <Row>
                                        <Col>
                                            <p>Dia de Pagamento</p>
                                            <h4>{company.due_day}</h4>
                                        </Col>
                                        <Col>
                                            <p>Dias para Bloqueio após Vencimento</p>
                                            <h4>{company.days_to_block}</h4>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <p>Criado em</p>
                                            <h4>{(new Date(company.created_at)).toLocaleDateString('pt-br')}</h4>
                                        </Col>
                                        <Col>
                                            <p>Atualizado em</p>
                                            <h4>{(new Date(company.updated_at)).toLocaleDateString('pt-br')}</h4>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <Row>
                        <Col>
                            <Card className="mb-3">
                                <CardHeader>
                                    Informações sobre Gestor
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <p>Nome</p>
                                            <h4>{company && company.manager && company.manager.name}</h4>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <p>Email</p>
                                            <h4>{company && company.manager && company.manager.auth && company.manager.auth.email}</h4>
                                        </Col>
                                        <Col>
                                            <p>Status</p>
                                            <h4>{company && company.manager && company.manager.is_activated ? 'Sim' : 'Não'}</h4>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <p>Criado em</p>
                                            <h4>{company && company.manager && (new Date(company.manager.created_at)).toLocaleDateString('pt-br')}</h4>
                                        </Col>
                                        <Col>
                                            <p>Atualizado em</p>
                                            <h4>{company && company.manager && (new Date(company.manager.updated_at)).toLocaleDateString('pt-br')}</h4>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Card className="mb-3">
                        <CardHeader>
                            Auditorias realizadas
                        </CardHeader>
                        <CardBody>
                            <Table responsive>
                                <thead>
                                <tr>
                                    <th>Feito em</th>
                                    <th>Auditor</th>
                                    <th>Observação</th>
                                </tr>
                                </thead>
                                <tbody>
                                {company.audits && company.audits.map(audit => {
                                    return <tr key={audit.id}>
                                        <td>
                                            {(new Date(audit.created_at)).toLocaleDateString('pt-br')}
                                        </td>
                                        <td>
                                            {audit.auditor && audit.auditor.name}
                                        </td>
                                        <td>
                                            {audit.observation}
                                        </td>
                                    </tr>
                                })}

                                {company.audits && !company.audits.length && <tr>
                                    <td colSpan={3} style={{textAlign: 'center'}}>
                                        Não há itens para exibição
                                    </td>
                                </tr>}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

        </Page>
    };
}

const mapStateToProps = state => {
    return {user: state.userReducer.user};
};

export default connect(mapStateToProps)(CompanyDetailPage);



// WEBPACK FOOTER //
// ./src/pages/company/CompanyDetailPage.js